import moment from 'moment';
import LimitUsageViewer from "../LimitUsageViewer";
import { jsx as _jsx } from "react/jsx-runtime";
const DateRangeLimitUsageViewer = ({
  label,
  limit = {
    from: null,
    to: null
  }
}) => {
  let dateRange = 'None';
  if (!limit.from && limit.to) {
    dateRange = `to ${moment(limit.to).format('YYYY-MM-DD')}`;
  }
  if (!limit.to && limit.from) {
    dateRange = `from ${moment(limit.from).format('YYYY-MM-DD')}`;
  }
  if (limit.from && limit.to) {
    dateRange = `${moment(limit.from).format('YYYY-MM-DD')} — ${moment(limit.to).format('YYYY-MM-DD')}`;
  }
  return limit.from || limit.to ? /*#__PURE__*/_jsx(LimitUsageViewer, {
    limit: dateRange,
    label: label
  }) : null;
};
export default DateRangeLimitUsageViewer;